export const authRole = {
  admin: ['user', 'admin'],
  user: ['user'],
};

export const RoutePermittedRole = {
  admin: 'admin',
  user: 'user',
};

export const ThemeStyle = {
  MODERN: 'modern',
  STANDARD: 'standard',
};

export const ThemeMode = {
  LIGHT: 'light',
  SEMI_DARK: 'semi-dark',
  DARK: 'dark',
};

export const LayoutType = {
  FULL_WIDTH: 'full-width',
  BOXED: 'boxed',
  FRAMED: 'framed',
};

export const MenuStyle = {
  DEFAULT: 'default',
  STANDARD: 'standard',
  ROUNDED: 'rounded',
  ROUNDED_REVERSE: 'rounded-reverse',
  CURVED_MENU: 'curved-menu',
};

export const NavStyle = {
  DEFAULT: 'default',
  MINI: 'mini',
  MINI_SIDEBAR_TOGGLE: 'mini-sidebar-toggle',
  STANDARD: 'standard',
  HEADER_USER: 'user-header',
  HEADER_USER_MINI: 'user-mini-header',
  DRAWER: 'drawer',
  BIT_BUCKET: 'bit-bucket',
  H_DEFAULT: 'h-default',
  HOR_HEADER_FIXED: 'hor-header-fixed',
  HOR_DARK_LAYOUT: 'hor-dark-layout',
};

export const FooterType = {
  FIXED: 'fixed',
  FLUID: 'fluid',
};

export const ThemeDirection = {
  RTL: 'rtl',
  LTR: 'ltr',
};

export const UploadType = {
  PICTURE: 'PICTURE',
  ICON: 'ICON',
  FILE: 'FILE',
  SMALLPICTURE: 'SMALLPICTURE',
};

export enum DaysOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

export enum TreatmentStatus {
  Pending = 0,
  Prescription = 1,
  Imperssion = 2,
}

export enum TreatmentTypeValues {
  Aligner = 1,
  Whitening = 2,
  Retainers = 3,
}

export enum NotificationTypeValue {
  TreatmentOrder = 1,
  ClinicRequest = 2,
  CaseOrder = 3,
}

export enum FolderName {
  Impressions = 1,
  TreatmentPhotos = 2,
  Xrays = 3,
  ProfilePhotos = 4,
  TreatmentPlan = 5,
  AgentCompanyLogos = 10,
  ChatAttachments = 11,
}
export enum TreatmentPackage {
  Ultimate = 0,
  AsYouGo,
  EcoPlan,
  Retainer,
  WhiteningTube,
  WhiteningMold,
}
